
// import kinderGarde from "../resources/kindergarde/Kindergarde_mit_Trainer.jpg"
// import jugendGarde from "../resources/jugendgarde/1_Jugend_2025.jpg"
// import kleinerHofstaat from "../resources/jugendgarde/2_Kleiner_Hofstaat_2025.jpg"
// import grosserHofstaat from "../resources/1_Große_Garde_2025.jpg"
// import trainerGroß from "../resources/2_Trainer_Große_Garde_2025.jpg"
// import trainerKlein from "../resources/jugendgarde/3_Trainer_KleinerHofstaat.jpg"

function Garde() {

  const KinderAlle = () => (
    <img
      src="https://storage.googleapis.com/eggspatzen-data-bucket/kindergarde/2026/Kindergarde_2026.jpg"
      alt="Kindergarde"
      className="col-6"
      loading="lazy"
    />
  );

  const JugendAlle = () => (
    <img
      src="https://storage.googleapis.com/eggspatzen-data-bucket/jugendgarde/2026/Jugend_gesamt_2026.jpg"
      alt="Jugendgarde"
      className="col-6"
      loading="lazy"
    />
  );

  const KleinerHofstaat = () => (
    <img
      src="https://storage.googleapis.com/eggspatzen-data-bucket/kindergarde/2026/Kleiner_Hofstaat_2026.jpg"
      alt="Kleiner Hofstaat"
      className="col-6"
      loading="lazy"
    />
  );

  const Hofis = () => (
     <img
      src="https://storage.googleapis.com/eggspatzen-data-bucket/vorstand/Hofis_2026.jpg"
      alt="Hofis"
      className="col-3"
    />
  )

  const TrainerKlein = () => (
    <img
      src="https://storage.googleapis.com/eggspatzen-data-bucket/jugendgarde/2025/3_Trainer_KleinerHofstaat.jpg"
      alt="Trainer Kleiner Hofstaat"
      className="col-6"
      loading="lazy"
    />
  );

  const TrainerGr = () => (
    <img
      src="https://storage.googleapis.com/eggspatzen-data-bucket/gro%C3%9Fegarde/2026/Trainer_Gross_2026.jpg"
      alt="Trainer Grosser Hofstaat"
      className="col-6"
      loading="lazy"
    />
  );

  const GrHofstaat = () => (
    <img
      src="https://storage.googleapis.com/eggspatzen-data-bucket/gro%C3%9Fegarde/2026/Grosse_Garde_2026.jpg"
      alt="Grosser Hofstaat"
      className="col-7"
    />
  );

  const kinder = [36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50]

  const kids = kinder.map(person =>
    <li className="col-md-4 verticalDiv">
      <img
        src={"https://storage.googleapis.com/eggspatzen-data-bucket/kindergarde/2026/Kinder_2026_" + person + ".jpg"}
        alt={person}
        className="garde_img"
        loading="lazy"
      />
    </li>
  );


  const teenies = [9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26]

  const teens = teenies.map(person =>
    <li className="col-md-4 verticalDiv">
      <img
        // src={require(`../resources/jugendgarde/${person}_2025.jpg`)}
        src={"https://storage.googleapis.com/eggspatzen-data-bucket/jugendgarde/2026/Jugend_2026_" + person + ".jpg"}
        alt={person}
        className="garde_img"
        loading="lazy"
      />
    </li>
  );

  const gross = [67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84]

  const old = gross.map(person =>
    <li className="col-md-4 verticalDiv">
      <img
        // src={require(`../resources/großegarde/${person}_2025.jpg`)}
        src={"https://storage.googleapis.com/eggspatzen-data-bucket/gro%C3%9Fegarde/2026/Grosse_2026_" + person + ".jpg"}
        alt={person}
        className="garde_img"
      />
    </li>
  );

  return (
    <div className="AktiveGarde">

      <div className="pagecontent">
        <p>DIE AKTIVE MANNSCHAFT 2025/2026</p>
      </div>
      <p className="heading_smallsize">Der große und kleine Hofstaat kann zusammen und separat gebucht werden.</p>

      <div className="horizontalDiv row">
        <p className="pagecontent">DER GROSSE HOFSTAAT</p>
        {/* <img className="col-10" src={grosserHofstaat}></img> */}
        <GrHofstaat></GrHofstaat>
      </div>

      <div className="container">
        <ul className="row">{old}</ul>
      </div>

      <div className="horizontalDiv row">
        <p className="heading_midsize">TRAINER GROSSER HOFSTAAT</p>
        {/* <img className="col-9" src={trainerGroß}></img> */}
        <TrainerGr></TrainerGr>
        <p className="heading_smallsize">Christina, Sabrina, Carolin, Bea, Marlene, Katja, Steffi (nicht im Bild: Jana)</p>
      </div>

      <div className="horizontalDiv row">
        <p className="heading_midsize">UNSERE HOFMARSCHÄLLE</p>
        {/* <img className="col-9" src={trainerGroß}></img> */}
        <Hofis></Hofis>
        <p className="heading_smallsize">Die Moderation übernimmt im großen Hofstaat Lisa (links) und für den kleinen Hofstaat Franzi (rechts).</p>
      </div>

      <div className="horizontalDiv row">
        <p className="pagecontent">DER KLEINE HOFSTAAT</p>
        {/* <img className="col-10" alt="kleiner Hofstaat" src={kleinerHofstaat}></img> */}
        <KleinerHofstaat></KleinerHofstaat>
      </div>

      <div className="horizontalDiv row">
        <p className="heading_midsize">DIE KINDERGARDE</p>
        {/* <img className="col-9" alt="Kindergarde" src={kinderGarde}></img> */}
        <KinderAlle></KinderAlle>
      </div>
      <div className="container">
        <ul className="row">{kids}</ul>
      </div>


      <div className="horizontalDiv row">
        <p className="heading_midsize">DIE JUGENDGARDE</p>
        {/* <img className="col-9" alt="Jugendgarde" src={jugendGarde}></img> */}
        <JugendAlle></JugendAlle>
      </div>
      <div className="container">
        <ul className="row">{teens}</ul>
      </div>

      <div className="horizontalDiv row">
        <p className="heading_midsize">TRAINER KLEINER HOFSTAAT</p>
        {/* <img className="col-9" src={trainerKlein}></img> */}
        <TrainerKlein></TrainerKlein>
        <p className="heading_smallsize">Anna, Amina, Andrea, Lena, Leonie, Lilly, Daniela</p>
      </div>

    </div>
  );
}

export default Garde;